import { FireOutbreakReactionEnum } from '../../../../@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'
import { FireOutbreakReaction } from './FireOutbreakReaction.abstract'

export class NotOccurredFireOutbreakOptionStrategy extends FireOutbreakReaction {
	constructor() {
		super('Negativo', 'material-symbols:thumb-down-rounded', FireOutbreakReactionEnum.NEGATIVE)
	}
}
